import { render, staticRenderFns } from "./ChatGptSender.vue?vue&type=template&id=0a2408cd"
import script from "./ChatGptSender.vue?vue&type=script&lang=js"
export * from "./ChatGptSender.vue?vue&type=script&lang=js"
import style0 from "./ChatGptSender.vue?vue&type=style&index=0&id=0a2408cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports